import { NavigationItem } from '.';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import AdminPanelSettingsOutlined from '@mui/icons-material/AdminPanelSettingsOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import PageInfoIcon from '@/components/icons/configuration';

const navigationItems: NavigationItem[] = [
  {
    text: 'Dashboard',
    route: '/dashboard',
    icon: <DashboardOutlinedIcon />,
  },
  {
    text: 'Clients',
    route: '/Advisor/Clients',
    icon: <PersonOutlined />,
    children: [
      { text: 'Clients', route: '/Advisor/Clients' },
      /* TODO: Add prospects tab once the prospects page is implemented */
      // { text: "Prospects", route: "/Advisor/Clients/Prospects" },
    ],
  },
  {
    text: "Client's Wealth",
    route: '/Advisor/Wealth',
    icon: <AccountBalanceOutlinedIcon />,
    children: [
      { text: 'Accounts', route: '/clients-wealth/accounts' },
      { text: 'Holdings', route: '/clients-wealth/holdings' },
      { text: 'Asset Allocation', route: '/clients-wealth/asset-allocation' },
      { text: 'Balance Sheet', route: '/clients-wealth/balance-sheet' },
    ],
  },
  {
    text: 'Analytics',
    route: '/Analytics',
    icon: <AnalyticsOutlinedIcon />,
    children: [
      { text: 'Metrics' },
      {
        text: 'AUM & Held Away',
        route: '/business-intelligence/aum-held-away',
      },
      { text: 'Insights', route: '/business-intelligence/insights' },
    ],
  },
  {
    text: 'Configuration',
    route: '/Configuration',
    icon: <PageInfoIcon />,
    children: [
      { text: 'Legal', route: '/Advisor/Configuration/Legal' },
      { text: 'Integrations', route: '/Advisor/Configuration/Integrations' },
    ],
  },
  {
    text: 'Documents',
    route: '/documents',
    icon: <DescriptionOutlined />,
    children: [
      { text: 'Document Vault', route: '/documents/document-vault' },
      { text: 'Reports' },
      { text: 'Notes', route: '/documents/notes' },
    ],
  },
  {
    text: 'Team',
    route: '/team',
    icon: <GroupOutlined />,
  },
  {
    text: 'Admin',
    route: '/admin',
    icon: <AdminPanelSettingsOutlined />,
    children: [
      { text: 'User Administration', route: '/admin/user-administration' },
    ],
  },
];

export default navigationItems;
